interface Props {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'horizontal' | 'compact' | 'stacked';
  className?: string;
}

const sizeMap: Record<NonNullable<Props['size']>, string> = {
  sm: '15px',
  md: '19px',
  lg: '28px',
};

/**
 * Sheahan Studios wordmark — Fraunces 600, sentence case, finished with a
 * single gold full stop (the brand signature). Colour follows --color-fg so it
 * reads ink-on-paper in light and paper-on-dark in the admin dark theme.
 * The dot is a real period coloured gold, never recoloured or made interactive.
 */
export default function Wordmark({ size = 'md', variant = 'horizontal', className = '' }: Props) {
  const fontSize = sizeMap[size];

  const base: React.CSSProperties = {
    fontFamily: 'Fraunces, Georgia, serif',
    fontWeight: 600,
    fontSize,
    letterSpacing: '-0.01em',
    color: 'var(--color-fg)',
    display: 'inline-flex',
    alignItems: 'flex-start',
    lineHeight: 1,
  };

  const dot = <span style={{ color: 'var(--color-gold, #b8915a)' }}>.</span>;

  // Compact: the "S" monogram + dot, for very tight spaces.
  if (variant === 'compact') {
    return (
      <span className={className} style={base}>
        S{dot}
      </span>
    );
  }

  if (variant === 'stacked') {
    return (
      <span className={className} style={{ ...base, flexDirection: 'column', lineHeight: 0.95 }}>
        <span>Sheahan</span>
        <span>
          Studios{dot}
        </span>
      </span>
    );
  }

  return (
    <span className={className} style={base}>
      Sheahan&nbsp;Studios{dot}
    </span>
  );
}
